import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger)

export default {
  mounted() {
    // gsap.to('.news-featured li', {
    //   scrollTrigger: {
    //     trigger: ".news-featured",
    //     start: "0% 80%",
    //     end: "0% 80%",
    //     toggleActions: 'play none reverse none',
    //   },
    //   duration: 1.25,
    //   width: '100%',
    //   stagger: 0.1
    // });

    gsap.utils.toArray("[data-parallax]").forEach(element => {
      gsap.to(element, {
        scrollTrigger: {
          scrub: 2,
          // invalidateOnRefresh: true
        },
        y: (i, target) => element.dataset.parallax,
        ease: "none"
      });
    });
  }
}